import { useCallback, useEffect, useState } from "react";
import RtsScanStore from "./RtsScanStore";
import { AddRtsAgent } from "../../app/api/rts/AddRtsAgent";
import { toast } from "react-toastify";
import { Box, MenuItem, TextField, Typography } from "@mui/material";

const LocationComponent = () => {
  const { location, rtsUserClient, setLocation } = RtsScanStore();
  const [isLocSelectedByuser, setLocSelectedByUser] = useState(false);

  useEffect(() => {
    const getLocation = async () => {
      try {
        const position: any = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });
        const { latitude, longitude } = position.coords;
        // set initial location with fenced = false.
        setLocation(latitude, longitude, false);
        //check for store location, if fenced then set true.
        findStoreByLocation(latitude, longitude);
      } catch (error: any) {
        toast.error(error.message);
      }
    };
    getLocation();
  }, []);

  useEffect(() => {
    if (rtsUserClient) {
      setLocSelectedByUser(false);
    }
  }, [rtsUserClient]);

  useEffect(() => {
    if (rtsUserClient && location.clientId && !isLocSelectedByuser) {
      setDefaultStoreBasisSelectedClientEmail();
    }
  }, [rtsUserClient, location, isLocSelectedByuser]);

  const setDefaultStoreBasisSelectedClientEmail = () => {
    const { clientId, redundantLocations, latitude, longitude } = location;
    if (clientId === rtsUserClient?.id) {
      return;
    }
    if (redundantLocations) {
      const selectedClientStore = redundantLocations.find(
        (loc: any) => loc.clientId === rtsUserClient?.id
      );
      if (selectedClientStore) {
        setLocation(
          latitude,
          longitude,
          true,
          selectedClientStore.storeId,
          selectedClientStore.clientId,
          selectedClientStore.storePk,
          redundantLocations
        );
        return;
      }
    }
  };

  const findStoreByLocation = useCallback(
    async (latitude: number, longitude: number) => {
      try {
        const geofenceResponse = await AddRtsAgent.checkGeofence({
          latitude: latitude,
          longitude: longitude,
        });
        console.log("geofence response:", geofenceResponse);
        if (geofenceResponse?.data?.body?.fenced) {
          setLocation(
            latitude,
            longitude,
            true,
            geofenceResponse?.data?.body?.storeId,
            geofenceResponse?.data?.body?.clientId,
            geofenceResponse?.data?.body?.storePk,
            geofenceResponse?.data?.body?.redundantLocations
          );
        } else {
          toast.error("Not in geofence area");
        }
      } catch (error) {
        console.error("Error checking location details:", error);
      }
    },
    []
  );

  const handleChange = (event: any) => {
    const selectedStroreId = event.target.value;
    let selectedClientStore = null;
    if (location.redundantLocations) {
      selectedClientStore = location.redundantLocations.find(
        (loc: any) => loc.storeId === selectedStroreId
      );
    }
    setLocSelectedByUser(true);
    setLocation(
      location.latitude,
      location.longitude,
      true,
      selectedStroreId,
      selectedClientStore ? selectedClientStore.clientId : location.clientId,
      selectedClientStore.storePk,
      location.redundantLocations
    );
  };

  return (
    <>
      {location.latitude !== 0 ? (
        <p>
          Location : {location.latitude}, {location.longitude}
          {location.isFenced ? (
            <span>, Store: {location.storeId}</span>
          ) : (
            <span>, not in geofence area. </span>
          )}
        </p>
      ) : (
        <p>Provide required GPS permissions to check location. </p>
      )}

      {location.redundantLocations &&
        location.redundantLocations.filter(
          (loc: any) => loc.clientId === rtsUserClient?.id
        ).length > 1 && (
          <Box display="flex" alignItems="center">
            <Typography mr={1}>Store:</Typography>
            <TextField
              sx={{ marginTop: -1 }}
              margin="normal"
              size="small"
              fullWidth
              select
              onChange={handleChange}
              value={location.storeId}
            >
              {location.redundantLocations
                .filter((loc: any) => loc.clientId === rtsUserClient?.id)
                .map((loc: { storeId: string; storePk: number }) => (
                  <MenuItem key={loc.storePk} value={loc.storeId}>
                    {loc.storeId}
                  </MenuItem>
                ))}
            </TextField>
          </Box>
        )}
    </>
  );
};
export default LocationComponent;
